import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { Segment, Table } from 'semantic-ui-react'
import { loadCustomerOrders, loadDealerOrders } from '../../../redux/carts'
import CartBrowserRow from './CartBrowserRow'

const mapStateToProps = (state, ownProps) => {
  const {
    loadingDealerOrders,
    loadingCustomerOrders,
    dealerOrders = {},
    customerOrders = {},
  } = state.carts
  const {
    match: {
      params: { cart_id },
    },
  } = ownProps
  const loadingOrders =
    ownProps.kind === 'dealer_orders'
      ? loadingDealerOrders
      : loadingCustomerOrders
  const orders =
    ownProps.kind === 'dealer_orders' ? dealerOrders : customerOrders
  return { loadingOrders, orders, cart_id: Number(cart_id) }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { push, loadDealerOrders, loadCustomerOrders },
    dispatch
  )
}

class CartBrowser extends React.PureComponent {
  state = {
    sortCol: 'finalized_at',
    direction: 'descending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  dashboardActions() {
    const { orders, push, kind } = this.props
    return [
      {
        icon: 'chevron right',
        secondary: true,
        content: I18n.t('admin.carts.browser.all', { count: orders.count }),
        onClick: (event) => {
          event.preventDefault()
          push(config.nodes[kind.slice(0, -1)])
        },
      },
    ]
  }

  getTableRows() {
    const { direction } = this.state
    const { orders, kind } = this.props
    const { carts } = this.props.orders
    const { cart_id } = this.props.match.params
    if (orders.length === 0) return false
    const sortedOrders = carts.sort((a, b) =>
      a.data.finalized_at.localeCompare(b.data.finalized_at)
    )
    return direction === 'ascending'
      ? sortedOrders
      : sortedOrders
          .reverse()
          .map((order) => (
            <CartBrowserRow
              key={order.id}
              order={order}
              selected={order.id === +cart_id}
              kind={kind}
            />
          ))
  }

  render() {
    const dark = config.theme.dark
    const { dashboard, loadingOrders, kind, orders } = this.props
    const { sortCol, direction } = this.state

    return loadingOrders ? (
      <ComponentPlaceholder />
    ) : (
      <div
        className={classNames([
          'cartBrowser',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={I18n.t(
            `admin.carts.browser.title.${kind}${dashboard ? '_newest' : ''}`,
            { numCarts: orders.length }
          )}
          badge={dashboard ? 'carts' : undefined}
          actions={dashboard ? this.dashboardActions() : []}
        />

        <Segment
          attached
          className={classNames([
            'payload',
            'hide-print',
            'clip',
            dark && 'inverted',
          ])}>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Header>
              <Table.Row>
                <SortableHeaderCell
                  collapsing
                  name="finalized_at"
                  title={I18n.t('admin.carts.browser.date')}
                  onClick={() => this.sortBy('finalized_at')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <Table.HeaderCell
                  name="address1"
                  content={I18n.t('admin.carts.browser.name')}
                />
                <Table.HeaderCell
                  textAlign="right"
                  name="sum"
                  content={I18n.t('admin.carts.browser.products')}
                />
              </Table.Row>
            </Table.Header>
            <Table.Body children={this.getTableRows()} />
          </Table>
        </Segment>
      </div>
    )
  }
}

CartBrowser = connect(mapStateToProps, mapDispatchToProps)(CartBrowser)
export default withRouter(CartBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CartBrowser.jsx